import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwtDecode from "jwt-decode";
import themeFile from "./util/theme";
import axios from "axios";

//Redux Stuff
import { Provider } from "react-redux";
import store from "./redux/store";
import { SET_AUTHENTICATED } from "./redux/types";
import { logoutUser, getUserData } from "./redux/actions/userActions";

//Material Ui Stuff
import {
  ThemeProvider as MuiThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

//Components
import Navbar from "./Components/Layout/Navbar";
import AuthRoute from "./util/AuthRoute";

//Pages
import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import User from "./Pages/User";
import Home from "./Pages/Home";
import Landing from "./Pages/Landing";
import About from "./Pages/About";
import Terms from "./Pages/Terms";

let theme = createMuiTheme(themeFile);
theme = responsiveFontSizes(theme);

axios.defaults.baseURL =
  "https://us-central1-studybud-6bcea.cloudfunctions.net/api";

const token = localStorage.fbIdToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logoutUser());
    window.location.href = "/login";
  } else {
    store.dispatch({ type: SET_AUTHENTICATED });
    axios.defaults.headers.common["Authorization"] = token;
    store.dispatch(getUserData());
  }
}

const App = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/home" component={Home} />
            <AuthRoute exact path="/login" component={Login} />
            <AuthRoute exact path="/signup" component={SignUp} />
            <Route exact path="/users/:username" component={User} />
            <Route
              exact
              path="/users/:username/post/:postId"
              component={User}
            />
            <Route exact path="/about" component={About} />
            <Route exact path="/en/terms" component={Terms} />
            <Route
              path="/support"
              component={() => {
                window.location.href = "https://donorbox.org/studybud-support";
                return null;
              }}
            />
          </Switch>
        </Router>
      </Provider>
    </MuiThemeProvider>
  );
};

export default App;
